import { Box, useTheme } from "@mui/material";


import MoveDownIcon from '@mui/icons-material/MoveDown';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useFinishPickingJobMutation, useFullCompletePickingJobMutation, useOpenPickingJobMutation } from "../../../../newapi/pickingjob/pickingjobSlice";
import { tokens } from "../../../../theme";
import PopoverModal from "../../../theme/Modal/PopoverModal";
import Text from "../../../theme/text/Text";
import { ActionButton } from "./components/ActionButton";
import { ActionIcon } from "./components/ActionIcon";
import MEcheckTransferJob from "../MEcheckTransferJob";
import MConfirmation from "../MConfirmation";
import { toast } from "react-toastify";
import NotInterestedOutlinedIcon from '@mui/icons-material/NotInterestedOutlined'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { EditOutlined, LocalPrintshopOutlined } from "@mui/icons-material";
import MConfirmDelete from "../MConfirmDelete";
import { useDeleteSerialNumberMutation, useUpdateSerialNumberMutation } from "../../../../newapi/inbound/serialNumberSlice";
import MConfirmationWithValue from "../MConfirmationWithValue";
export const AMInboundToProcess = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);

    const [updateSerialNumber, {isLoading: serialNumberUpdateLoading}] = useUpdateSerialNumberMutation();
    const [deleteSerialNumber, {isLoading: deleteSerialNumberLoading}] = useDeleteSerialNumberMutation();

    

    const [confirmEndStreamModalOpen, setConfirmEndStreamModalOpen] = useState(false);
    const confirmEndStreamModal = {
        open: confirmEndStreamModalOpen,
        setOpen: setConfirmEndStreamModalOpen,
    };

    const handleConfirmEndStreamClose = () => {
        confirmEndStreamModal.setOpen(false);
    };

    const handleEndStream = async (value) => {
        if(serialNumberUpdateLoading) return;

        await updateSerialNumber({
            id:props.item.id,
            barcode: value
        })
        .unwrap()
        .then(res => {
            props.setHighlightColor("green");
            props.onClose();
            props.refetchJobAndLoad();
        })
        .catch(error => {
            props.setHighlightColor('red');
            toast.error(error.data?.message ??  `Er is iets misgegaan`, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        });
    }
    

    const [deleteSerialNumberModalOpen, setDeleteSerialNumberModalOpen] = useState(false);
    const deleteSerialNumberModal = {
        open: deleteSerialNumberModalOpen,
        setOpen: setDeleteSerialNumberModalOpen,
    };

    const handleDeleteSerialNumberClose = () => {
        deleteSerialNumberModal.setOpen(false);
    };

    const handleCompleteStream = async () => {
        if(deleteSerialNumberLoading) return;

        await deleteSerialNumber(props.item?.id)
        .unwrap()
        .then(res => {
            props.setHighlightColor("green");
            props.onClose();
            props.refetchJobAndLoad();
            // props.refetchJobs();
        })
        .catch(error => {
            console.log(error);
            props.setHighlightColor('red');
            toast.error(error.data?.message ??  `Er is iets misgegaan`, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        });
    }

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }
    

    return (
        <PopoverModal
            {...props}
        >
            <Box 
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[100] : "#fff",
                    padding:1.5,
                    paddingBottom: isStandAlone ? 4 : 1.5,
                    display:"flex",
                    gap:1,
                    flexDirection:"column",
                    borderRadius:"24px",
                    borderBottomLeftRadius:0,
                    borderBottomRightRadius:0,
                    "@media screen and (max-width: 48em)" : {
                        borderRadius:"32px",
                        borderBottomLeftRadius:0,
                        borderBottomRightRadius:0,

                    }
                }}
            >
               

                <ActionButton
                    onClick={() => {
                        props.onClose();
                        props.onPrintBarcode(props.item.barcode);
                    }}
                >
                    <ActionIcon
                    >
                        <LocalPrintshopOutlined fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('print_barcode')}
                        </Text>
                    </Box>
                </ActionButton>

                <ActionButton
                    onClick={() => {
                        confirmEndStreamModal.setOpen(true);
                    }}
                >
                    <ActionIcon>
                        <EditOutlined fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('update_serial_number')}
                        </Text>
                    </Box>
                </ActionButton>
                <ActionButton
                    onClick={() => {
                        setDeleteSerialNumberModalOpen(true);
                    }}
                >
                    <ActionIcon
                        color={colors.red[400]}
                    >
                        <NotInterestedOutlinedIcon fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('delete_serial_number')}
                        </Text>
                    </Box>
                </ActionButton>


            </Box>
            
            <MConfirmationWithValue
                data={{
                    hasInput:true,
                    inputType:"text",
                    // value:"",
                    title:t("update_serial_number")
                }}
                open={confirmEndStreamModal.open}
                handleClose={handleConfirmEndStreamClose}
                confirm={handleEndStream}
            />
            <MConfirmDelete
                open={deleteSerialNumberModal.open}
                data={props.item?.barcode}
                handleClose={handleDeleteSerialNumberClose}
                title={t("delete_serial_number")}
                confirm={() => handleCompleteStream(true)}
            />

        </PopoverModal>
    );
}

